module.exports = __webpack_public_path__ + "static/media/cr.0d349fd2.svg";